module.exports = __webpack_public_path__ + "static/media/15a.65128ddc.jpg";